import React from "react";
import { InchUtility, /* pipeSizes */ } from "../../../lib/pipe-dataset";
import Riser from "./PipeAccesories/pipe-riser.component";
import InsertaTee from "./PipeAccesories/pipe-insertaTee.component";
import CleanOut from "./PipeAccesories/pipe-cleanout.component";
import Stub from "./PipeAccesories/pipe-stub.component";
import {
    PIPE_ELEMENT_TYPE_BEND,
    PIPE_ELEMENT_TYPE_STICK,
    PIPE_ELEMENT_TYPE_SINGLE_TEE,
    PIPE_ELEMENT_TYPE_DOUBLE_TEE,
    PIPE_ELEMENT_TYPE_TRIPLE_TEE,
    PIPE_POSITION_LEFT,
    PIPE_POSITION_CENTER,
    PIPE_POSITION_RIGHT,
    PIPE_ACCESSORY_RISER,
    PIPE_ACCESSORY_STUB_INVERT_MATCHING,
    PIPE_ACCESSORY_STUB_CONCENTRIC,
    PIPE_ACCESSORY_STUB_CROWN_MATCHING,
    PIPE_ACCESSORY_CLEANOUT_LEFT,
    PIPE_ACCESSORY_CLEANOUT,
    PIPE_ACCESSORY_CLEANOUT_RIGHT,
    PIPE_ACCESSORY_INSERTA_TEE,
    PIPE_ACCESSORY_ROUND_BASIN,
    PIPE_ACCESSORY_SQUARE_BASIN
} from "../../../lib/types";
import { Circle, Group, Rect } from "react-konva";
import { getScaledPixels } from "../../../lib/calculations";

const renderAccessory = ( accessory, x, y, rotation, diameter, key, element ) => {
    console.log("rendering", accessory.type, accessory.size);

    let strokeWidth, lessDiameter;


    switch (accessory.type) {
        case PIPE_ACCESSORY_RISER:
            return <Riser
                x={x}
                y={y}
                key={key}
                diameter={diameter}
                rotation={rotation}
            />
        case PIPE_ACCESSORY_INSERTA_TEE:
            return <InsertaTee
                x={x}
                y={y}
                key={key}
                diameter={diameter}
                rotation={rotation}
            />
        case PIPE_ACCESSORY_CLEANOUT:
            return <CleanOut
                key={key}
                diameter={diameter}
                rotation={270}
                x={x}
                y={y - element.height / 2.8}
            />
        case PIPE_ACCESSORY_CLEANOUT_LEFT:
            return <CleanOut
                key={key}
                diameter={diameter}
                rotation={180}
                x={x - element.width / 2.8}
                y={y + diameter}
            />
        case PIPE_ACCESSORY_CLEANOUT_RIGHT:
            return <CleanOut
                key={key}
                diameter={diameter}
                rotation={270}
                x={x}
                y={y - element.height / 2.8}
            />
        case PIPE_ACCESSORY_STUB_INVERT_MATCHING:
        case PIPE_ACCESSORY_STUB_CONCENTRIC:
        case PIPE_ACCESSORY_STUB_CROWN_MATCHING:
            return <Stub
                key={key}
                diameter={diameter}
                rotation={rotation}
                x={x}
                y={y}
            />;
        case PIPE_ACCESSORY_ROUND_BASIN:
            strokeWidth = getScaledPixels(0.05);
            lessDiameter = diameter - strokeWidth * 2;
            return (<Group x={x} y={y}>
                <Circle radius={diameter} stroke={"red"} fill={"white"} strokeWidth={strokeWidth}/>
                <Circle radius={lessDiameter} stroke={"red"} fill={"white"} strokeWidth={strokeWidth}/>
            </Group>);
        case PIPE_ACCESSORY_SQUARE_BASIN:
            strokeWidth = getScaledPixels(0.05);
            lessDiameter = diameter - strokeWidth * 4;
            return <Group>
                <Rect x={x - strokeWidth * 2} y={y - strokeWidth * 2} stroke={"red"} fill={"white"} width={diameter} height={diameter}
                      strokeWidth={strokeWidth}/>
                <Rect stroke={"red"} fill={"white"} width={lessDiameter} height={lessDiameter} strokeWidth={strokeWidth}/>
            </Group>;
        default:
            throw new Error(`Unrecognized accessory:${accessory.type}`);
    }
}

const renderBendAccessories = ( element, placeholders ) => {
    /* diameter an dcenter point of the bend */
    let diameter, x, y;
    let accessories = [];
    /* x y init function */
    const initXY = () => {
        x = element.width / 2;
        y = element.height / 2;
    };

    let {left, top, right} = placeholders[PIPE_POSITION_CENTER];

    if (left) {
        initXY();
        diameter = new InchUtility(left.size).px;
        x = 0;
        accessories.push(renderAccessory(left, x, y, 180, diameter, 0, element));
    }
    if (right) {
        initXY();
        diameter = new InchUtility(right.size).px;
        x -= diameter / 1.6;
        y = 0;
        accessories.push(renderAccessory(right, x, y, 270, diameter, 2, element));
    }
    if (top) {
        initXY();
        if (top.type === PIPE_ACCESSORY_ROUND_BASIN) {
            diameter = element.width * 0.5;
            x = 0.4 * element.width;
            y = 0.4 * element.height;
        } else if (top.type === PIPE_ACCESSORY_SQUARE_BASIN) {
            diameter = element.width * 0.85;
            x = 0;
            y = 0;
        } else {
            diameter = new InchUtility(top.size).px;
            x -= diameter / 1.6;
            y -= diameter / 1.3;
        }
        accessories.push(renderAccessory(top, x, y, 0, diameter, 1, element));
    }
    return accessories;
};

const renderStickAccessories = ( element, placeholders ) => {
    /* diameter an dcenter point of the stick */
    let diameter, x, y;
    let accessories = [];
    /* x y init function */
    const initXY = () => {
        x = element.width / 2;
        y = element.height / 2 + element.offSet;
    };

    let {left, top, right} = placeholders[PIPE_POSITION_CENTER];

    if (left) {
        initXY();
        diameter = new InchUtility(left.size).px;
        x = 0;
        y += diameter / 2;
        accessories.push(renderAccessory(left, x, y, 180, diameter, 0, element));
    }
    if (top) {
        initXY();
        diameter = new InchUtility(top.size).px;
        x -= diameter / 2;
        y -= diameter / 2;
        accessories.push(renderAccessory(top, x, y, 0, diameter, 1, element));
    }
    if (right) {
        initXY();
        diameter = new InchUtility(right.size).px;
        x = element.width;
        y -= diameter / 2;
        accessories.push(renderAccessory(right, x, y, 0, diameter, 0, element));
    }
    return accessories;
};

const renderTeeAccessories = ( element, placeholders ) => {
    /* diameter an dcenter point of the bend */
    let offSet = element.offSet;
    /*  if tee is double, we need to adjust offset for right item in order to be
        positioned properly, otherwise it will use the triple tee offset to place
        on the right */
    let doubleOffset = (element.type === PIPE_ELEMENT_TYPE_DOUBLE_TEE) ? offSet / 2 : 0;
    let diameter, x, y;
    let accessories = [];
    /* x y init function */
    const initXY = () => {
        x = element.width / 2;
        y = element.height / 2;
    };

    if (placeholders.hasOwnProperty(PIPE_POSITION_LEFT)) {
        let {top, side} = placeholders[PIPE_POSITION_LEFT];
        if (side) {
            initXY();
            diameter = new InchUtility(side.size).px;
            x -= (diameter / 1.6 + offSet - doubleOffset);
            y = 0;
            accessories.push(renderAccessory(side, x, y, 270, diameter, 1, element));
        }
        if (top) {
            initXY();
            diameter = new InchUtility(top.size).px;
            x = offSet / 2 - diameter / 2;
            y -= diameter / 1.2;
            accessories.push(renderAccessory(top, x, y, 0, diameter, 0, element));
        }
    }
    if (placeholders.hasOwnProperty(PIPE_POSITION_RIGHT)) {
        let {top, side} = placeholders[PIPE_POSITION_RIGHT];
        if (side) {
            initXY();
            diameter = new InchUtility(side.size).px;
            x -= (diameter / 1.6 - offSet + doubleOffset);
            y = 0;
            accessories.push(renderAccessory(side, x, y, 270, diameter, 5, element));
        }
        if (top) {
            initXY();
            diameter = new InchUtility(top.size).px;
            x += offSet - diameter / 2 - doubleOffset;
            y -= diameter / 1.2;
            accessories.push(renderAccessory(top, x, y, 0, diameter, 4, element));
        }
    }
    if (placeholders.hasOwnProperty(PIPE_POSITION_CENTER)) {
        let {top, side} = placeholders[PIPE_POSITION_CENTER];
        if (side) {
            initXY();
            diameter = new InchUtility(side.size).px;
            x -= diameter / 1.6;
            y = 0;
            accessories.push(renderAccessory(side, x, y, 270, diameter, 3, element));
        }
        if (top) {
            initXY();
            diameter = new InchUtility(top.size).px;
            x -= diameter / 2;
            y -= diameter / 1.2;
            accessories.push(renderAccessory(top, x, y, 0, diameter, 2, element));
        }
    }
    return accessories;
};

export const renderAccessoryHelper = ( element, {placeholders} ) => {
    /* if not accessories present, return */
    if (!placeholders) {
        return []
    }
    switch (element.type) {
        case PIPE_ELEMENT_TYPE_BEND:
            return renderBendAccessories(element, placeholders);
        case PIPE_ELEMENT_TYPE_STICK:
            return renderStickAccessories(element, placeholders);
        case PIPE_ELEMENT_TYPE_SINGLE_TEE:
        case PIPE_ELEMENT_TYPE_DOUBLE_TEE:
        case PIPE_ELEMENT_TYPE_TRIPLE_TEE:
            return renderTeeAccessories(element, placeholders);
        default:
            return [];
    }
}



// WEBPACK FOOTER //
// ./src/components/Drawings/Pipes/pipe-accessory-helper.js